import { Component, OnInit } from "@angular/core";
import { IntegratedAdmissionControlWizardService } from "../service/integrated-admission-control.wizard.service";
import { IntegratedAdmissionWizardService } from "../service/integrated-admission-wizard.service";
import { InvoiceIntegratedAdmissionCashDeskService } from "src/app/services/invoice-cash-desk/invoice-integrated-admission-cash-desk.service";
import { InvoiceCashDeskService } from "src/app/services/invoice-cash-desk/invoice-cash-desk.service";

@Component({
  selector: "app-integrated-admission-control-wizard",
  providers: [
    {
      provide: IntegratedAdmissionWizardService,
      useClass: IntegratedAdmissionControlWizardService,
    },
    {
      provide: InvoiceCashDeskService,
      useClass: InvoiceIntegratedAdmissionCashDeskService,
    },
  ],

  templateUrl: "./integrated-admission-control-wizard.component.html",
  styleUrls: ["./integrated-admission-control-wizard.component.css"],
})
export class IntegratedAdmissionControlWizardComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
